import { PageHero, CTABand } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { Landmark, HeartPulse, Hotel, Scale, BookOpen, GraduationCap } from "lucide-react";

const SECTORS = [
  { icon: Landmark, name: "Government", desc: "Secure, compliant relocation protocols for federal, state, and local agencies — cleared crews, documented chain of custody, and GSA-aligned processes." },
  { icon: HeartPulse, name: "Medical Facilities", desc: "Specialized transport for sensitive diagnostic equipment, medical assets, and records in active care environments where downtime is not an option." },
  { icon: Hotel, name: "Hospitality", desc: "FF&E deployment, model-room staging, and rapid floor-by-floor room turnaround for hotel groups and resort properties." },
  { icon: Scale, name: "Law Firms", desc: "High-density document security, sensitive litigation file transit, and after-hours moves that keep billable teams billing." },
  { icon: BookOpen, name: "Libraries & Museums", desc: "Archival collections, rare specimens, and historical artifacts moved with temperature-controlled protection and curator-level handling." },
  { icon: GraduationCap, name: "Universities & Schools", desc: "Campus-wide dorm, lab, library, and administrative relocations timed to academic calendars and summer windows." },
];

export default function Industries() {
  return (
    <main data-testid="industries-page">
      <PageHero
        eyebrow="Industries We Serve"
        title="Specialized moving for specialized worlds"
        subtitle="Every industry moves differently. We bring sector-specific crews, equipment, and protocols to each one."
      />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SECTORS.map((s, i) => (
            <Reveal key={s.name} delay={(i % 3) * 0.08}
              className="group bg-white border border-slate-200 rounded-md p-8 hover:border-brand hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
              <div className="w-12 h-12 bg-brand-subtle rounded-sm flex items-center justify-center mb-5 group-hover:bg-brand transition-colors">
                <s.icon size={24} className="text-brand group-hover:text-white transition-colors" />
              </div>
              <h3 className="font-display font-semibold text-xl text-navy mb-2">{s.name}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand />
    </main>
  );
}
